import { render } from "./ViewAddSourceObject.vue?vue&type=template&id=10d2cb5d&scoped=true"
import script from "./ViewAddSourceObject.vue?vue&type=script&lang=js"
export * from "./ViewAddSourceObject.vue?vue&type=script&lang=js"

import "./ViewAddSourceObject.vue?vue&type=style&index=0&id=10d2cb5d&lang=scss&scoped=true"

import exportComponent from "/app/tmp/aft/V3/v2026.19.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d2cb5d"]])

export default __exports__